/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./backgroundJobList.vue?vue&type=template&id=0ab4fa44"
import script from "./backgroundJobList.vue?vue&type=script&lang=js"
export * from "./backgroundJobList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports